import {Link, useLocation} from 'react-router-dom';
import React, {useContext, useState} from 'react';
import EventEmitter from '../utils/emmiter';
import {UserContext} from '../utils/usercontext';
//import AudioPlayer from './components/audio/audioplayer';
import {useracc, postApi} from '../utils/functions';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';

//import './css/header.css';

export default function Header() {

	//const [metaClubbers, setMetaClubbers] = useState({connected: 0, dj: '', artist: '', title: '', art: '', time: 0, listeners: 0});
	//const [metaRadio, setMetaRadio] = useState({connected: 0, dj: '', artist: '', title: '', art: '', time: 0, listeners: 0});
	
	const {user} = useContext(UserContext);
	const [page, setPage] = useState('index');
	const [subPage, setSubPage] = useState('');
	const [mobile, setmobile] = useState(false);
	const [hover, setHover] = useState(false);
	const [index, setIndex] = useState(-1);
	const [active, setActive] = useState(false);

  const [services, setServices] = useState([]);
	

	let location = useLocation();

  async function Loadeader() {
    let params = new URLSearchParams();
		const x = await postApi('/v3/portal/header', params);
    setServices(x.data.Services);
  }

	/*function toggleSidemenu(event) {
		let element = document.getElementById('landing-page-wrapper');
		if( element && element.contains(event.target) ) { // or use: event.target.closest(selector) === null
			let html = document.documentElement;
			if( html ) html.setAttribute("data-toggled", 'close');
		}


	}*/

	function openSidemenu() {
		let element = document.documentElement;
		
		if( window.innerWidth < 992 ) {
			setActive(true);
			element.removeAttribute("data-toggled");
			setTimeout(()=>{
				element.removeAttribute("data-toggled");
			},100);
		} else {
			let attribute = element.getAttribute("data-toggled");
			
			if( attribute ) {
				element.removeAttribute("data-toggled");
				setHover(false);
			} else {
				element.setAttribute("data-toggled", "icon-overlay-close");
				setHover(true);
			}
		}
		
	}

	function toggleSidemenu(status) {
		if( hover ) {
			let element = document.documentElement;
			//let attribute = element.getAttribute("data-toggled");
			//console.log(attribute);
			if( status ) {
				element.removeAttribute("data-toggled");
				

			} else {
				element.setAttribute("data-toggled", "icon-overlay-close");
			}
		}
	}


	function changeMode() {
		let element = document.documentElement;
		let attribute = element.getAttribute("data-theme-mode");
		if( attribute === 'light' ) {
			element.setAttribute("data-theme-mode", "dark");
		} else {
			element.setAttribute("data-theme-mode", "light");
		}
		
	}

	function closeSidebar() {
		//if( window.innerWidth > 991 )
		setActive(false);
		let element = document.documentElement;
		element.setAttribute("data-toggled", "close");
	}

	React.useEffect(() => {

    Loadeader();
		
		function updateSize() {
			let element = document.documentElement;
			if( window.innerWidth < 992 ) {
				element.setAttribute("data-toggled", "close");
			} else {
				
				element.removeAttribute("data-toggled");
			}
      //setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();

		EventEmitter.addListener('/clubbers/meta', async data => {
			//setMetaClubbers(data.azura);
		});
		EventEmitter.addListener('/radio/meta', async data => {
			//setMetaRadio(data.azura);
		});

    /*
		switch(true) {
			case /^\/about/.test(location.pathname):
				setPage('mix365'); setSubPage('about');
				break;
			case /^\/events/.test(location.pathname):
				setPage('mix365'); setSubPage('events');
				break;
			case /^\/mix365djs/.test(location.pathname):
				setPage('mix365'); setSubPage('mix365djs');
				break;
			case /^\/previous-sets/.test(location.pathname):
				setPage('mix365'); setSubPage('previous-sets');
				break;
			case /^\/listen/.test(location.pathname):
				setPage('mix365'); setSubPage('listen');
				break;
			
			case /^\/schedule/.test(location.pathname):
				setPage('schedule'); setSubPage('');
				break;

			case /^\/clubbers\/schedule/.test(location.pathname):
				setPage('schedule'); setSubPage('clubbers/schedule');
				break;
			case /^\/clubbers/.test(location.pathname):
				setPage('chatlive'); setSubPage('clubbers');
				break;
			case /^\/radio\/schedule/.test(location.pathname):
				setPage('schedule'); setSubPage('radio/schedule');
				break;
			case /^\/radio/.test(location.pathname):
				setPage('chatlive'); setSubPage('radio');
				break;

			case /^\/contact/.test(location.pathname):
				setPage('contact'); setSubPage('contact');
				break;
			case /^\/apply/.test(location.pathname):
				setPage('contact'); setSubPage('apply');
				break;
			case /^\/advertise/.test(location.pathname):
				setPage('contact'); setSubPage('advertise');
				break;

			case /^\/shop/.test(location.pathname):
				setPage('shop'); setSubPage('');
				break;

			case /^\/login/.test(location.pathname):
				setPage('login'); setSubPage('');
				break;

			case /^\/register/.test(location.pathname):
				setPage('register'); setSubPage('');
				break;

			case /^\/djarea$/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea');
				break;
			case /^\/djarea\/members/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/members');
				break;
			case /^\/djarea\/connection/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/connection');
				break;
			case /^\/djarea\/socials/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/socials');
				break;
			case /^\/djarea\/posters/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/posters');
				break;
			case /^\/djarea\/files/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/files');
				break;
			case /^\/djarea\/logs/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/logs');
				break;


			case /^\/admin$/.test(location.pathname):
				setPage('admin'); setSubPage('admin');
				break;
			case /^\/admin\/djaccounts/.test(location.pathname):
				setPage('admin'); setSubPage('admin/djaccounts');
				break;
			case /^\/admin\/events/.test(location.pathname):
				setPage('admin'); setSubPage('admin/events');
				break;
			case /^\/admin\/weekly/.test(location.pathname):
				setPage('admin'); setSubPage('admin/weekly');
				break;
			case /^\/admin\/publish/.test(location.pathname):
				setPage('admin'); setSubPage('admin/publish');
				break;
			case /^\/admin\/seo/.test(location.pathname):
				setPage('admin'); setSubPage('admin/seo');
				break;

			default:
				setPage('index'); setSubPage('');
				break;
		}
    */
  }, [location]);
	

	//console.log(user);

	const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
		<a className="header-link dropdown-toggle" id="mainHeaderProfile" href="" ref={ref} onClick={(e)=>{e.preventDefault();onClick(e);}}>
			{children}
		</a>
	));

	const CustomMenu = React.forwardRef(({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
		const [value, setValue] = useState('');
		return (
			<div ref={ref} style={style} className={className} aria-labelledby={labeledBy}>
				<ul className="dropdown-menu border-0 main-header-dropdown  overflow-hidden header-profile-dropdown show" aria-labelledby="mainHeaderProfile">
					{React.Children.toArray(children).filter(
						(child) => !value || child.props.children.toLowerCase().startsWith(value),
					)}
				</ul>
			</div>
		);
	});
		

	function SidemenuHeader(props) {
		return (
			<>
				<li className="slide__category"><span className="category-name">{props.service.product}</span></li>
				<li className="slide has-sub">
					<Link to={`/${props.service.id}`} className="side-menu__item">
						<span className=" side-menu__icon">
							<i className='bx bx-home'></i>
						</span>
						<span className="side-menu__label">{props.service.title.length>0?props.service.title:'Overview'}</span>
						<i className="fe fe-chevron-right side-menu__angle"></i>
					</Link>
				</li>
			</>
		)
	}

	function SidemenuLiveStream(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/live`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-video'></i>
					</span>
					<span className="side-menu__label">Live Stream</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}

	function SidemenuSchedule(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/schedule`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-list-ul'></i>
					</span>
					<span className="side-menu__label">Schedule</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}

	function SidemenuEmojiCrew(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/template`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-party'></i>
					</span>
					<span className="side-menu__label">EmojiCrew</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}

	function SidemenuDropsJingles(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/filemanager`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-podcast'></i>
					</span>
					<span className="side-menu__label">File Manager</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}

	function SidemenuReplays(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/replays`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-play-circle'></i>
					</span>
					<span className="side-menu__label">Replays</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}

	function SidemenuAdmin(props) {
		return (
			<>
				<li className="slide has-sub">
					<div style={{borderTop: '1px solid rgba(255, 255, 255, .1)'}}></div>
				</li>
				<li className="slide has-sub">
					<Link to={`/${props.service.id}/admin`} className="side-menu__item">
						<span className=" side-menu__icon">
							<i className='bx bx-lock-alt'></i>
						</span>
						<span className="side-menu__label">Admin Overview</span>
						<i className="fe fe-chevron-right side-menu__angle"></i>
					</Link>
				</li>
			</>
		)
	}

	function SidemenuInvites(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/invites`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-user'></i>
					</span>
					<span className="side-menu__label">Invites</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}

	function SidemenuDJAccounts(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/accounts`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-user-plus'></i>
					</span>
					<span className="side-menu__label">DJ Accounts</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}

	function SidemenuPlatforms(props) {
		return(
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/platforms`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-video-plus'></i>
					</span>
					<span className="side-menu__label">Streaming Platforms</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}
	function SidemenuOrganiser(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/organiser`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-list-check'></i>
					</span>
					<span className="side-menu__label">Schedule Organiser</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}

	function SidemenuVideos(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/recordings`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-video-recording'></i>
					</span>
					<span className="side-menu__label">Video Recordings</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}

	return (
		<>
			{user?.user &&
				<>
					<header id="landing-page-wrapper" className="app-header sticky-pin">
						<div className="main-header-container container-fluid">

							<div className="header-content-left">
								<div className="header-element">
									<div className="horizontal-logo">
										<a href="https://laravelui.spruko.com/velvet/index" className="header-logo">
											<img src="https://laravelui.spruko.com/velvet/build/assets/images/brand-logos/desktop-logo.png" alt="logo" className="desktop-logo" />
											<img src="https://laravelui.spruko.com/velvet/build/assets/images/brand-logos/toggle-logo.png" alt="logo" className="toggle-logo" />
											<img src="https://laravelui.spruko.com/velvet/build/assets/images/brand-logos/desktop-dark.png" alt="logo" className="desktop-dark" />
											<img src="https://laravelui.spruko.com/velvet/build/assets/images/brand-logos/toggle-dark.png" alt="logo" className="toggle-dark" />
										</a>
									</div>
								</div>
										
								<div className="header-element">
									<a aria-label="anchor" href="#" onClick={()=>{openSidemenu()}} className="sidemenu-toggle header-link" data-bs-toggle="sidebar">
                    <span className="open-toggle me-2">
                      <i className="bx bx-menu header-link-icon"></i>
                    </span>
									</a>
									<div className="main-header-center  d-none d-lg-block  header-link">
										{/*<input type="text" className="form-control form-control-lg" id="typehead" placeholder="Search for results..." autocomplete="off" />
										<button type="button"  aria-label="button" className="btn pe-1"><i className="fe fe-search" aria-hidden="true"></i></button>
										<div id="headersearch" className="header-search">
											<div className="p-3">
												<div className="">
													<p className="fw-semibold text-muted mb-2 fs-13">Recent Searches</p>
													<div className="ps-2">
														<a  href="javascript:void(0)" className="search-tags"><i className="fe fe-search me-2"></i>People<span></span></a>
														<a  href="javascript:void(0)" className="search-tags"><i className="fe fe-search me-2"></i>Pages<span></span></a>
														<a  href="javascript:void(0)" className="search-tags"><i className="fe fe-search me-2"></i>Articles<span></span></a>
													</div>
												</div>
												<div className="mt-3">
													<p className="fw-semibold text-muted mb-2 fs-13">Apps and pages</p>
													<ul className="ps-2">
														<li className="p-1 d-flex align-items-center text-muted mb-2 search-app">
															<a href="https://laravelui.spruko.com/velvet/full-calendar"><span><i className="bx bx-calendar me-2 fs-14 bg-primary-transparent p-2 rounded-circle"></i>Calendar</span></a>
														</li>
														<li className="p-1 d-flex align-items-center text-muted mb-2 search-app">
															<a href="https://laravelui.spruko.com/velvet/mail"><span><i className="bx bx-envelope me-2 fs-14 bg-primary-transparent p-2 rounded-circle"></i>Mail</span></a>
														</li>
														<li className="p-1 d-flex align-items-center text-muted mb-2 search-app">
															<a href="https://laravelui.spruko.com/velvet/buttons"><span><i className="bx bx-dice-1 me-2 fs-14 bg-primary-transparent p-2 rounded-circle"></i>Buttons</span></a>
														</li>
													</ul>
												</div>
												<div className="mt-3">
													<p className="fw-semibold text-muted mb-2 fs-13">Links</p>
													<ul className="ps-2">
														<li className="p-1 align-items-center text-muted mb-1 search-app">
															<a href="javascript:void(0)" className="text-primary"><u>http://spruko/spruko.com</u></a>
														</li>
														<li className="p-1 align-items-center text-muted mb-1 search-app">
															<a href="javascript:void(0)" className="text-primary"><u>http://spruko/spruko.com</u></a>
														</li>
													</ul>
												</div>
											</div>
											<div className="py-3 border-top px-0">
												<div className="text-center">
													<a href="javascript:void(0)" className="text-primary text-decoration-underline fs-15">View all</a>
												</div>
											</div>
										</div>*/}
									</div>
								</div>
										
								<div className="header-element header-search d-lg-none d-block ">
									<a aria-label="anchor" href="javascript:void(0);" className="header-link" data-bs-toggle="modal" data-bs-target="#searchModal">
										<i className="bx bx-search-alt-2 header-link-icon"></i>
									</a>
								</div>

							</div>
							<div className="header-content-right">
								
								<div className="header-element header-theme-mode" style={{cursor: 'pointer'}}>
									<div className="header-link layout-setting" onClick={()=>changeMode()}>
										<i className="bx bx-sun bx-flip-horizontal header-link-icon ionicon  dark-layout"></i>
										<i className="bx bx-moon bx-flip-horizontal header-link-icon ionicon light-layout"></i>
										</div>
								</div>
								

										
								<div className="header-element cart-dropdown">
										
									<a href="javascript:void(0);" className="header-link dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="outside">
										<i className="bx bx-cart header-link-icon ionicon"></i>
										<span className="badge bg-danger rounded-pill header-icon-badge" id="cart-icon-badge">5</span>
									</a>
										
									<div className="main-header-dropdown dropdown-menu  border-0 dropdown-menu-end" data-popper-placement="none">
										<div className="p-3">
											<div className="d-flex align-items-center justify-content-between">
												<p className="mb-0 fs-17 fw-semibold">Cart Items</p>
												<span className="badge bg-success-transparent" id="cart-data">5 Items</span>
											</div>
										</div>
										<div><hr className="dropdown-divider" /></div>
										<ul className="list-unstyled mb-0" id="header-cart-items-scroll">
											<li className="dropdown-item border-bottom">
												<div className="d-flex align-items-start cart-dropdown-item">
													<span className="avatar avatar-xl bd-gray-200 p-1">
														<img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/1.png" alt="" />
													</span>
													<div className="flex-grow-1 ms-3">
														<div className="d-flex align-items-start justify-content-between mb-0">
															<div className=" fs-13 fw-semibold">
																<a href="https://laravelui.spruko.com/velvet/cart">Cactus mini plant</a>
															</div>
															<div>
																<a aria-label="anchor" href="javascript:void(0);" className="header-cart-remove float-end dropdown-item-close"><i className="ti ti-trash"></i></a>
															</div>
														</div>
														<div className="min-w-fit-content align-items-start">
															<div className=" fw-normal fs-12 text-muted">Quantity:02</div>
															<div className="d-flex  align-items-center">
																<span className=" fw-semibold fs-16">$1,229</span>
																<p className="text-muted text-decoration-line-through ms-1 op-6 fs-12 mb-0">$1,799</p>
															</div>
														</div>
													</div>
												</div>
											</li>
											<li className="dropdown-item border-bottom">
												<div className="d-flex align-items-start cart-dropdown-item">
													<span className="avatar avatar-xl bd-gray-200 p-1">
														<img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/15.png" alt="" />
													</span>
													<div className="flex-grow-1 ms-3">
														<div className="d-flex align-items-start justify-content-between mb-0">
															<div className=" fs-13 fw-semibold">
																<a href="https://laravelui.spruko.com/velvet/cart">Sports shoes for men</a>
															</div>
															<div>
																<a aria-label="anchor" href="javascript:void(0);" className="header-cart-remove float-end dropdown-item-close"><i className="ti ti-trash"></i></a>
															</div>
														</div>
														<div className="min-w-fit-content align-items-start">
															<div className=" fw-normal fs-12 text-muted">Quantity:01</div>
															<div className="d-flex  align-items-center">
																<span className=" fw-semibold fs-16">$10,229</span>
																<p className="text-muted text-decoration-line-through ms-1 op-6 fs-12 mb-0">$799</p>
															</div>
														</div>
													</div>
												</div>
											</li>
											<li className="dropdown-item border-bottom">
												<div className="d-flex align-items-start cart-dropdown-item">
													<span className="avatar avatar-xl bd-gray-200 p-1">
														<img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/40.png" alt="" />
													</span>
													<div className="flex-grow-1 ms-3">
														<div className="d-flex align-items-start justify-content-between mb-0">
															<div className=" fs-13 fw-semibold">
																<a href="https://laravelui.spruko.com/velvet/cart">Pink color smart watch </a>
															</div>
															<div>
																<a aria-label="anchor" href="javascript:void(0);" className="header-cart-remove float-end dropdown-item-close"><i className="ti ti-trash"></i></a>
															</div>
														</div>
														<div className="min-w-fit-content align-items-start">
															<div className=" fw-normal fs-12 text-muted">Quantity:03</div>
															<div className="d-flex  align-items-center">
																<span className=" fw-semibold fs-16">$5,500</span>
																<p className="text-muted text-decoration-line-through ms-1 op-6 fs-12 mb-0">$599</p>
															</div>
														</div>
													</div>
												</div>
											</li>
											<li className="dropdown-item border-bottom">
												<div className="d-flex align-items-start cart-dropdown-item">
													<span className="avatar avatar-xl bd-gray-200 p-1">
														<img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/8.png" alt="" />
													</span>
													<div className="flex-grow-1 ms-3">
														<div className="d-flex align-items-start justify-content-between mb-0">
															<div className=" fs-13 fw-semibold">
																<a href="https://laravelui.spruko.com/velvet/cart">Red Leafs plant </a>
															</div>
															<div>
																<a aria-label="anchor" href="javascript:void(0);" className="header-cart-remove float-end dropdown-item-close"><i className="ti ti-trash"></i></a>
															</div>
														</div>
														<div className="min-w-fit-content align-items-start">
															<div className=" fw-normal fs-12 text-muted">Quantity:01</div>
															<div className="d-flex  align-items-center">
																<span className=" fw-semibold fs-16">$15,300</span>
																<p className="text-muted text-decoration-line-through ms-1 op-6 fs-12 mb-0">$799</p>
															</div>
														</div>
													</div>
												</div>
											</li>
											<li className="dropdown-item">
												<div className="d-flex align-items-start cart-dropdown-item">
													<span className="avatar avatar-xl bd-gray-200 p-1">
														<img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/11.png" alt="" />
													</span>
													<div className="flex-grow-1 ms-3">
														<div className="d-flex align-items-start justify-content-between mb-0">
															<div className=" fs-13 fw-semibold">
																<a href="https://laravelui.spruko.com/velvet/cart">Good luck mini plant</a>
															</div>
															<div>
																<a aria-label="anchor" href="javascript:void(0);" className="header-cart-remove float-end dropdown-item-close"><i className="ti ti-trash"></i></a>
															</div>
														</div>
														<div className="min-w-fit-content align-items-start">
															<div className=" fw-normal fs-12 text-muted">Quantity:02</div>
															<div className="d-flex  align-items-center">
																<span className=" fw-semibold fs-16">$600</span>
																<p className="text-muted text-decoration-line-through ms-1 op-6 fs-12 mb-0">$99</p>
															</div>
														</div>
													</div>
												</div>
											</li>
										</ul>
										<div className="p-3 empty-header-item border-top">
											<div className="d-grid">
												<a href="https://laravelui.spruko.com/velvet/checkout" className="btn btn-primary">Checkout</a>
											</div>
										</div>
										<div className="p-5 empty-item d-none">
											<div className="text-center">
												<span className="avatar avatar-xxl avatar-rounded bg-warning-transparent">
													<i className="bx bx-cart bx-tada fs-2"></i>
												</span>
												<h6 className="fw-bold mb-2 mt-3">Your Cart is Empty</h6>
												<a href="https://laravelui.spruko.com/velvet/products" className="btn btn-primary btn-wave btn-sm m-1" data-abc="true">continue shopping <i className="bi bi-arrow-right ms-1"></i></a>
											</div>
										</div>
									</div>
										
								</div>
										

										
								<div className="header-element notifications-dropdown ">
										
									<a href="javascript:void(0);" className="header-link dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="outside" id="messageDropdown" aria-expanded="false">
										<i className="bx bx-bell bx-flip-horizontal header-link-icon ionicon"></i>
										<span className="badge bg-info rounded-pill header-icon-badge pulse pulse-secondary" id="notification-icon-badge">5</span>
									</a>
										
										
									<div className="main-header-dropdown dropdown-menu  border-0 dropdown-menu-end" data-popper-placement="none">
										<div className="p-3">
											<div className="d-flex align-items-center justify-content-between">
												<p className="mb-0 fs-17 fw-semibold">Notifications</p>
												<span className="badge bg-secondary-transparent" id="notifiation-data">5 Unread</span>
											</div>
										</div>
										<div className="dropdown-divider"></div>
											<ul className="list-unstyled mb-0" id="header-notification-scroll">
												<li className="dropdown-item">
													<div className="d-flex align-items-start">
														<div className="pe-2">
															<span className="avatar avatar-md bg-secondary-transparent rounded-2">
																<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/2.jpg" alt="" />
															</span>
														</div>
														<div className="flex-grow-1 d-flex  justify-content-between">
															<div>
																<p className="mb-0 fw-semibold"><a href="https://laravelui.spruko.com/velvet/notifications">Olivia James</a></p>
																<span className="fs-12 text-muted fw-normal">Congratulate for New template start</span>
															</div>
															<div className="min-w-fit-content ms-2 text-end">
																<a aria-label="anchor" href="javascript:void(0);" className="min-w-fit-content text-muted me-1 dropdown-item-close1"><i className="ti ti-x fs-14"></i></a>
																<p className="mb-0 text-muted fs-11">2 min ago</p>
															</div>
														</div>
													</div>
												</li>
												<li className="dropdown-item">
													<div className="d-flex align-items-start">
														<div className="pe-2">
															<span className="avatar avatar-md bg-warning-transparent rounded-2"><i className="bx bx-pyramid fs-18"></i></span>
														</div>
														<div className="flex-grow-1 d-flex  justify-content-between">
															<div>
																<p className="mb-0 fw-semibold"><a href="https://laravelui.spruko.com/velvet/notifications">Order Placed <span className="text-warning">ID: #1116773</span></a></p>
																<span className="fs-12 text-muted fw-normal header-notification-text">Order Placed Successfully</span>
															</div>
															<div className="min-w-fit-content ms-2 text-end">
																<a aria-label="anchor" href="javascript:void(0);" className="min-w-fit-content text-muted me-1 dropdown-item-close1"><i className="ti ti-x fs-14"></i></a>
																<p className="mb-0 text-muted fs-11">5 min ago</p>
															</div>
														</div>
													</div>
												</li>
												<li className="dropdown-item">
													<div className="d-flex align-items-start">
														<div className="pe-2">
															<span className="avatar avatar-md bg-secondary-transparent rounded-2">
																<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/8.jpg" alt="" />
															</span>
														</div>
														<div className="flex-grow-1 d-flex  justify-content-between">
															<div>
																<p className="mb-0 fw-semibold"><a href="https://laravelui.spruko.com/velvet/notifications">Elizabeth Lewis</a></p>
																<span className="fs-12 text-muted fw-normal">added new schedule realease date</span>
															</div>
															<div className="min-w-fit-content ms-2 text-end">
																<a aria-label="anchor" href="javascript:void(0);" className="min-w-fit-content text-muted me-1 dropdown-item-close1"><i className="ti ti-x fs-14"></i></a>
																<p className="mb-0 text-muted fs-11">10 min ago</p>
															</div>
														</div>
													</div>
												</li>
												<li className="dropdown-item">
													<div className="d-flex align-items-start">
														<div className="pe-2">
															<span className="avatar avatar-md bg-primary-transparent rounded-2"><i className="bx bx-pulse fs-18"></i></span>
														</div>
														<div className="flex-grow-1 d-flex  justify-content-between">
															<div>
																<p className="mb-0 fw-semibold"><a href="https://laravelui.spruko.com/velvet/notifications">Your Order Has Been Shipped</a></p>
																<span className="fs-12 text-muted fw-normal header-notification-text">Order No: 123456 Has Shipped To Your Delivery Address</span>
															</div>
															<div className="min-w-fit-content ms-2 text-end">
																<a aria-label="anchor" href="javascript:void(0);" className="min-w-fit-content text-muted me-1 dropdown-item-close1"><i className="ti ti-x fs-14"></i></a>
																<p className="mb-0 text-muted fs-11">12 min ago</p>
															</div>
														</div>
													</div>
												</li>
												<li className="dropdown-item">
													<div className="d-flex align-items-start">
														<div className="pe-2">
															<span className="avatar avatar-md bg-pink-transparent rounded-2"><i className="bx bx-badge-check"></i></span>
														</div>
														<div className="flex-grow-1 d-flex  justify-content-between">
															<div>
																<p className="mb-0 fw-semibold"><a href="https://laravelui.spruko.com/velvet/notifications">Account Has Been Verified</a></p>
																<span className="fs-12 text-muted fw-normal  header-notification-text">Your Account Has Been Verified Sucessfully</span>
															</div>
															<div className="min-w-fit-content ms-2 text-end">
																<a aria-label="anchor" href="javascript:void(0);" className="min-w-fit-content text-muted me-1 dropdown-item-close1"><i className="ti ti-x fs-14"></i></a>
																<p className="mb-0 text-muted fs-11">20 min ago</p>
															</div>
														</div>
													</div>
												</li>
											</ul>
											<div className="p-3 empty-header-item1 border-top">
												<div className="d-grid">
													<a href="https://laravelui.spruko.com/velvet/notifications" className="btn btn-primary">View All</a>
												</div>
											</div>
											<div className="p-5 empty-item1 d-none">
												<div className="text-center">
													<span className="avatar avatar-xl avatar-rounded bg-secondary-transparent">
														<i className="bx bx-bell-off bx-tada fs-2"></i>
													</span>
													<h6 className="fw-semibold mt-3">No New Notifications</h6>
												</div>
											</div>
										</div>
											
									</div>
											
												
									<div className="d-flex header-settings">
										<a aria-label="anchor"  href="javascript:void(0);" className=" header-link nav-link icon me-1" data-bs-toggle="offcanvas" data-bs-target="#sidebar-right" aria-controls="sidebar-right">
											<i className="bx bx-slider header-link-icon"></i>
										</a>
									</div>
											

									<Dropdown className="header-element mainuserProfile">
										<Dropdown.Toggle as={CustomToggle} id="dropdown-button-dark-example1">
											<div className="d-flex align-items-center">
												<div className="d-sm-flex wd-100p">
													<div className="avatar avatar-sm"><img alt="avatar" className="rounded-circle" src={`https://cloud.ultrastream.io${user.user.avatar}`} /></div>
													<div className="ms-2 my-auto d-none d-xl-flex">
														<h6 className=" font-weight-semibold mb-0 fs-13 user-name d-sm-block d-none">{user.user.title?user.user.title:user.user.username}</h6>
													</div>
												</div>
											</div>
										</Dropdown.Toggle>
										<Dropdown.Menu as={CustomMenu}>
											<Dropdown.Item eventKey="1" as={Link} to={`/profile/${user.user.username}`}><i className="fs-13 me-2 bx bx-user"></i>Profile</Dropdown.Item>
											<Dropdown.Item eventKey="2" as={Link} to="/messages"><i className="fs-13 me-2 bx bx-comment"></i>Message</Dropdown.Item>
											<Dropdown.Item eventKey="3" as={Link} to="/invoices"><i className="fs-13 me-2 bx bx-comment"></i>invoices</Dropdown.Item>
											<Dropdown.Item eventKey="4" as={Link} to="/settings"><i className="fs-13 me-2 bx bx-cog"></i>Settings</Dropdown.Item>
											<Dropdown.Item eventKey="5" as={Link} to="/news"><i className="fs-13 me-2 bx bx-help-circle"></i>Help</Dropdown.Item>
											<Dropdown.Item eventKey="6" as={Link} to="/logout"><i className="fs-13 me-2 bx bx-arrow-to-right"></i>Log Out</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
											
							</div>
						</div>
					</header>

					<aside className="app-sidebar" id="sidebar" onMouseEnter={()=>toggleSidemenu(true)} onMouseLeave={()=>toggleSidemenu(false)}>

                
                <div className="main-sidebar-header">
                    <a href="https://laravelui.spruko.com/velvet/index" className="header-logo">
                        <img src="https://laravelui.spruko.com/velvet/build/assets/images/brand-logos/desktop-logo.png" alt="logo" className="desktop-logo" />
                        <img src="https://laravelui.spruko.com/velvet/build/assets/images/brand-logos/toggle-logo.png" alt="logo" className="toggle-logo" />
                        <img src="https://laravelui.spruko.com/velvet/build/assets/images/brand-logos/desktop-dark.png" alt="logo" className="desktop-dark" />
                        <img src="https://laravelui.spruko.com/velvet/build/assets/images/brand-logos/toggle-dark.png" alt="logo" className="toggle-dark" />
                    </a>
                </div>
                
                <div className="main-sidebar" id="sidebar-scroll">

                    
                    <nav className="main-menu-container nav nav-pills flex-column sub-open">
                        <div className="slide-left" id="slide-left">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"> <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path> </svg>
                        </div>
                        <ul className="main-menu">
                            
                            <li className="slide__category"><span className="category-name">Main</span></li>
                            
                            <li className="slide has-sub">
                              <Link to="/" className="side-menu__item">
                                <span className=" side-menu__icon">
                                  <i className='bx bx-desktop'></i>
                                </span>
                                <span className="side-menu__label">Dashboard{/*<span className="badge bg-warning-transparent ms-2 d-inline-block">12</span>*/}</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>

														{/*
															Owner
																Webiste - 
															Technicians
																Servers	- Shows full list of servers and stats
															
															Support
																Services - Shows full list of services
																Tickets - Shows all support tickets
																(there may need to be a bit of server support in here)
														*/}
														<li className="slide has-sub">
                              <Link to="/websites" className="side-menu__item">
                                <span className=" side-menu__icon">
                                  <i className='bx bx-key'></i>
                                </span>
                                <span className="side-menu__label">Websites</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>

                            <li className="slide has-sub">
                              <Link to="/servers" className="side-menu__item">
                                <span className=" side-menu__icon">
                                  <i className='bx bx-key'></i>
                                </span>
                                <span className="side-menu__label">Servers</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>

														<li className="slide has-sub">
                              <Link to="/logs" className="side-menu__item">
                                <span className=" side-menu__icon">
                                  <i className='bx bx-key'></i>
                                </span>
                                <span className="side-menu__label">Logs</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>

                            <li className="slide has-sub">
                              <Link to="/services" className="side-menu__item">
                                <span className=" side-menu__icon">
                                  <i className='bx bx-news'></i>
                                </span>
                                <span className="side-menu__label">Services</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>
														<li className="slide has-sub">
                              <Link to="/streams" className="side-menu__item">
                                <span className=" side-menu__icon">
                                  <i className='bx bx-news'></i>
                                </span>
                                <span className="side-menu__label">Streams</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>
														<li className="slide has-sub">
                              <Link to="/clients" className="side-menu__item">
                                <span className=" side-menu__icon">
                                  <i className='bx bx-news'></i>
                                </span>
                                <span className="side-menu__label">Clients</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>
                            <li className="slide has-sub">
                              <Link to="/tickets" className="side-menu__item">
                                <span className=" side-menu__icon">
                                  <i className='bx bx-help-circle'></i>
                                </span>
                                <span className="side-menu__label">Tickets</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>
														<li className="slide has-sub">
                              <Link to="/template" className="side-menu__item">
                                <span className=" side-menu__icon">
                                  <i className='bx bx-help-circle'></i>
                                </span>
                                <span className="side-menu__label">Email Template</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>
														<li className="slide has-sub">
                              <Link to="/outbox" className="side-menu__item">
                                <span className=" side-menu__icon">
                                  <i className='bx bx-help-circle'></i>
                                </span>
                                <span className="side-menu__label">Email Outbox</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>
														<li className="slide has-sub">
                              <Link to="/system" className="side-menu__item">
                                <span className=" side-menu__icon">
                                  <i className='bx bx-help-circle'></i>
                                </span>
                                <span className="side-menu__label">System</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>
                            
                        </ul>
                        <div className="slide-right" id="slide-right"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"> <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path> </svg></div>
                    </nav>

                </div>

            </aside>

				</>
			}
		</>
	);
}
